// extracted by mini-css-extract-plugin
export default {"editButton":"onetimeDeduction_editButton__SHVAY","TableBody":"onetimeDeduction_TableBody__Be3IU","deleteButton":"onetimeDeduction_deleteButton__xw+nA"};